export default __webpack_public_path__ + "static/img/contact-bg.e3491bd.jpg";